import script from "./SaleOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleOrder.vue?vue&type=script&setup=true&lang=js"

import "./SaleOrder.vue?vue&type=style&index=0&id=1a74519e&lang=css"

const __exports__ = script;

export default __exports__